import { combineReducers } from 'redux';

import {
  LIBRARY_CATEGORIES_HUB_SET_LIST_CATEGORIES,
  LIBRARY_CATEGORIES_HUB_OPEN_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_HUB_CLOSE_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_HUB_SET_CATEGORY_DETAIL,
  LIBRARY_CATEGORIES_HUB_SET_META_CATEGORIES,
  LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_ITEMS,
  LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_META,
  LIBRARY_CATEGORIES_HUB_SHOW_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_HUB_HIDE_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_HUB_SET_DELETED_CATEGORY,
  LIBRARY_CATEGORIES_HUB_SHOW_DELETE_MODAL,
  LIBRARY_CATEGORIES_HUB_HIDE_DELETE_MODAL,
  LIBRARY_CATEGORIES_HUB_SET_CHANNEL_ASYNC_JOB,
} from '../../actions/businessLibrary/category/constants';
import createReducer from '../../utils/createReducer';

const categories = createReducer([], {
  [LIBRARY_CATEGORIES_HUB_SET_LIST_CATEGORIES]: (draft, { payload }) => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return payload.categories;
  },
});

const categoryDetail = createReducer(null, {
  [LIBRARY_CATEGORIES_HUB_SET_CATEGORY_DETAIL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.category,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_CATEGORIES_HUB_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_CATEGORIES_HUB_CLOSE_RIGHT_COLUMN]: () => false,
});

const categoryMeta = createReducer(
  {},
  {
    [LIBRARY_CATEGORIES_HUB_SET_META_CATEGORIES]: (_, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.meta,
  }
);

const assignToItems = createReducer(
  {
    items: [],
    meta: {},
  },
  {
    [LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_ITEMS]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft.items = payload.items;
    },

    [LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_META]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft.meta = payload.meta;
    },
  }
);

const showAssignToItemModal = createReducer(false, {
  [LIBRARY_CATEGORIES_HUB_SHOW_ASSIGN_TO_ITEM_MODAL]: () => true,
  [LIBRARY_CATEGORIES_HUB_HIDE_ASSIGN_TO_ITEM_MODAL]: () => false,
});

const deletedCategory = createReducer(null, {
  [LIBRARY_CATEGORIES_HUB_SET_DELETED_CATEGORY]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.deletedCategory,
});

const showDeleteModal = createReducer(false, {
  [LIBRARY_CATEGORIES_HUB_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_CATEGORIES_HUB_HIDE_DELETE_MODAL]: () => false,
});

const eventAsyncJob = createReducer(
  {
    channelName: null,
  },
  {
    [LIBRARY_CATEGORIES_HUB_SET_CHANNEL_ASYNC_JOB]: (_, { payload }) => ({
      // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
      ...payload,
    }),
  }
);

export default combineReducers({
  categories,
  categoryMeta,
  categoryDetail,
  eventAsyncJob,
  openRightColumn,
  assignToItems,
  showAssignToItemModal,
  deletedCategory,
  showDeleteModal,
});
